import * as STD                from '@emersya/mpa-std-lib';
import CM                      from '@emersya/mpa-components-manager-lib';
import { InputSelect, Image }         from '@emersya/mpa-components-lib';

export interface IProductEditorComponentConfiguration extends InputSelect.Configuration {
	// products are relative to the app so retrieve them from app config
};

export class ProductEditorComponent extends InputSelect.Component {
	static override getInputEventSubType() {
		const parentClass = (<(typeof CM.Component) []> <any> STD.object.getInheritanceChainFromClass(this))[ 1 ];
		if (!parentClass) {
			throw STD.errors.library('Should inherits from Input Select');
		}
		return parentClass.type;
	};

	static override initialize() {
		super.initialize();
	};

	private async addProduct(product : { SKU : string; viewerCode : string; iconURL : string }) {
		if (!app.basket) {
			throw new Error;
		}
		const basketProduct = await app.basket.basket.createProductAndInitialize({
			id :         product.SKU,
			title :      product.SKU,
			reference :  product.SKU,
			sku :        product.SKU,
			viewerCode : product.viewerCode,
			gtin :       null,
			quantity :   1,
			metaData :   {},
			parts :      [],
			pricing :    null
		});
		const tr = STD.translationsManager.languages.reduce<Record<string, string>>((a, c) => {
			a[ c ] = product.SKU;
			return a;
		}, {});
		const productTile = <CM.DOMComponent<any, any, any>> await this.component_instantiateOuterChild<ProductTileNS.Configuration>(
			{
				type :          'product-tile',
				id :            product.SKU,
				tree :          this.component_tree,
				slot :          null,
				isSlot :        false,
				declaredSlot :  null,
				configuration : {
					SKU :                    product.SKU,
					viewerCode :             product.viewerCode,
					iconURL :                product.iconURL,
					basketProduct,
					'@innerConfigurations' : {
						'image' : <Image.Configuration> {
							'@translations' : {
								'name' : tr
							},
							'URL' :           product.iconURL
						},
						'title' : {
							'@translations' : {
								'text' : tr
							}
						}
					}
				}
			}
		);
		void productTile;
	};

	override async component_initialize() {
		for (const product of app.component_configuration.products) {
			await this.addProduct({
				SKU :        product.SKU,
				iconURL :    product.iconURL,
				viewerCode : product[ 'viewer-code' ]
			});
		}
		await super.component_initialize();
	};

	override async component_start(ev : STD.events.Event<any, any>) {
		await super.component_start(ev);
	};

	protected override async onValueUpdated(ev : STD.events.Event<any, CM.Component<any, any>>) {
		await super.onValueUpdated(ev);
		if (app.basket && this.value) {
			if (!app.basket.basket.currentProduct || app.basket.basket.currentProduct.id != this.value.id) {
				await app.basket.basket.useProduct(this.value.id);
			}
		}
	};

	constructor(
		descriptor : ConstructorParameters<typeof CM.Component>[0],
		configuration : IProductEditorComponentConfiguration
	)
	{
		super(descriptor, configuration);
	};
};
export namespace NS {
	export const Component = ProductEditorComponent;
	export type Component = ProductEditorComponent;
	export type Configuration = IProductEditorComponentConfiguration;
}
;
import manifestXMLSource       from './ProductEditor.xml';
import './ProductEditor.scss';
import { NS as ProductTileNS } from '../ProductTile/ProductTile';

CM.declare({
	id :       'product-editor',
	type :     ProductEditorComponent,
	manifest : manifestXMLSource
});
